import {InjectionToken} from '@angular/core';
import {PhoneNumberUtil} from 'google-libphonenumber';

/**
 * Shared `google-libphonenumber` singleton.
 *
 * `providedIn:'root'` with its own factory rather than a provider registered in `app.config.ts`:
 * DI memoises the instance, the token tree-shakes when unused, and it needs no registration.
 */
export const PHONE_NUMBER_UTIL=new InjectionToken<PhoneNumberUtil>('phoneNumber.util',{
	providedIn:'root',
	factory:():PhoneNumberUtil=>PhoneNumberUtil.getInstance()
});
